// extracted by mini-css-extract-plugin
module.exports = {"notification":"style_notification__VwCT8","notification-item":"style_notification-item__O4KEl","isShow":"style_isShow__8Eiot","slideIn":"style_slideIn__T5zzE"};